<h1 class="title" i18n>LangPro Annotator</h1>

<p i18n>
    Welcome to LangPro Annotator, an annotation tool for LangPro, a natural
    language theorem prover developed at Utrecht University.
</p>

<p><em>This website is under construction. Please check again later.</em></p>
